/**
 * Obtenção dos contactos provenientes da API, e
 * realizado a estruturação dessa informação, de forma
 * a ser apresentada ao utilizador.
 *
 * @since 1.0.0
 * @category Hook
 * @param {Array} apiContacts
 * @param {Object} contacts
 *
 */
const getContacts = ({ apiContacts, contacts }) => {
    const availableContacts = [ 'email', 'mobile', 'phone' ];

    availableContacts.forEach( key => {
        const apiContact = apiContacts.find( contact => contact[key] );

        if ( apiContact )
            contacts[key] = apiContact[key];
    });
};

/**
 * Construção da estrutura base dos
 * contactos que irá ser submitida para API,
 * tanto no modelo client & user.
 *
 * @since 1.0.0
 * @category Hook
 * @param {Array} contacts
 * @param {Object} helpers
 *
 */
const buildContactsToAPI = ( contacts, helpers ) => contacts
    .filter( contact => contact.value )
    .reduce( ( contact, filterContact, index ) => {
        const apiValue = helpers.contacts?.find( helperContact => helperContact[filterContact.type] );

        if ( apiValue )
            contact[`contacts[${index}][id]`] = apiValue.id;

        contact[`contacts[${index}][type]`] = filterContact.type;
        contact[`contacts[${index}][value]`] = filterContact.value;
        return contact;
    }, {});

export {
    getContacts,
    buildContactsToAPI
};